import { Component } from 'react';
// Composants
import { Accordion, Button, Card, Dimmer, Form, Grid, Header, Icon, Input, Loader, Menu, Segment } from 'semantic-ui-react';
import CustomDropdown from '../../Utils/CustomDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PriceListTable from '../../Tables/PriceListTable';
import InfoIcon from '../../Utils/InfoIcon';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../../locales/i18n';
import { isMobileOnly } from 'react-device-detect';
// Ressources
import { faArrowLeft, faCheck, faDownload, faFlowerTulip, faGear, faList, faPlus, faTable, faTablePicnic, faTimes, faTrash, faTree } from '@fortawesome/pro-solid-svg-icons';
// Utils
import FormattersUtil from '../../../utils/FormattersUtil';
import StylesUtil from '../../../utils/StylesUtil';
// Services
import PriceListsService from '../../../services/PriceListsService';

const availableProperties = {
    default: { label: i18n.t("Prix fixe"), unit: '' },
    height: { label: i18n.t("Hauteur"), unit: 'm', category: 'Arbre' },
    circumference: { label: i18n.t("Circonférence"), unit: 'cm', category: 'Arbre' },
    crownDiameter: { label: i18n.t("Diamètre couronne"), unit: 'm', category: 'Arbre' },
    surface: { label: i18n.t("Surface"), unit: 'm²', category: 'Espace vert' },
    perimeter: { label: i18n.t("Périmètre"), unit: 'm', category: 'Espace vert' },
    length: { label: i18n.t("Longueur"), unit: 'm', category: 'Espace vert' }
};

class PriceListForm extends Component {
    state = {
        priceList: {
            label: '',
            currencyId: 1,
            priceThresholds: [{ property: 'height', values: [5, 10, 15, 20, 25] }],
            prices: []
        },
        openedAccordions: [],
        actions: [],
        showSettings: false,
        category: 'Arbre',
        searchQuery: '',
        displayType: 'list',
        error: { label: false },
        isUpdating: false
    };

    render() {
        const { isCreating } = this.props;
        const { priceList, category, showSettings, searchQuery, displayType, error, isUpdating } = this.state;
        const currencyOptions = this.props.currencies.map(currency => ({ text: `${currency.code}${currency.symbol ? ` (${currency.symbol})` : ''}`, value: currency.id }));

        return (
            <>
                <Dimmer active={isUpdating} style={StylesUtil.getMapStyles().dimmerStyle}>
                    <Loader content={isCreating ? i18n.t("Ajout de la configuration des actions en cours...") : i18n.t("Mise à jour de la configuration des actions en cours...")} />
                </Dimmer>

                <Form style={{ marginBottom: '10px' }}>
                    <Grid>
                        <Grid.Column width={8}>
                            <Form.Field
                                control={Input} label={`${i18n.t("Libellé")}* :`} placeholder='Ex : Configuration 1' style={{ marginBottom: isMobileOnly && '5px' }}
                                name='label' value={priceList?.label || ''} onChange={this.handleChange} error={error.label}
                            />
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <CustomDropdown
                                label={`${i18n.t("Devise")}* :`} selectOnBlur={false}
                                name='currencyId' options={currencyOptions} value={priceList.currencyId} onChange={this.handleChange}
                            />
                        </Grid.Column>
                    </Grid>
                </Form>
                <Menu attached='top' tabular className='left' style={{ marginTop: '5px', marginBottom: '5px', height: '39px' }}>
                    <Menu.Item
                        active={category === 'Arbre'} style={{ marginLeft: '5px' }}
                        onClick={() => { this.setState({ category: 'Arbre', openedAccordions: [] }); }}
                    >
                        <FontAwesomeIcon icon={faTree} style={{ marginRight: '10px' }} />{i18n.t("Arbres")}
                    </Menu.Item>
                    <Menu.Item
                        active={category === 'Espace vert'}
                        onClick={() => { this.setState({ category: 'Espace vert', openedAccordions: [] }); }}
                    >
                        <FontAwesomeIcon icon={faFlowerTulip} style={{ marginRight: '10px' }} />{i18n.t("Espaces verts")}
                    </Menu.Item>
                    <Menu.Item
                        active={category === 'Mobilier'}
                        onClick={() => { this.setState({ category: 'Mobilier', openedAccordions: [] }); }}
                    >
                        <FontAwesomeIcon icon={faTablePicnic} style={{ marginRight: '10px' }} />{i18n.t("Mobilier urbain")}
                    </Menu.Item>
                </Menu>
                {showSettings ? this.renderSettings()
                    :
                    <>
                        <div style={{ display: 'flex', gap: '7px' }}>
                            <Form>
                                <Form.Field control={Input} placeholder={i18n.t("Libellé de l'action")} title={i18n.t("Libellé de l'action")} value={searchQuery} icon='search' iconPosition='left' onChange={(_, { value }) => this.setState({ searchQuery: value })} />
                            </Form>
                            <Button.Group style={{ width: 'fit-content', marginLeft: 'auto' }}>
                                <Button className='button--secondary' disabled={displayType === 'list'} style={{ padding: '8px' }} onClick={() => this.setState({ displayType: 'list' })}>
                                    <FontAwesomeIcon icon={faList} />
                                </Button>
                                <Button className='button--secondary' disabled={displayType === 'table'} style={{ padding: '8px' }} onClick={() => this.setState({ displayType: 'table' })}>
                                    <FontAwesomeIcon icon={faTable} />
                                </Button>
                            </Button.Group>
                            {!isCreating &&
                                <Button
                                    className='button--secondary' icon='download' style={{ padding: '8px', marginRight: 0 }}
                                    disabled={!this.props.isOnline} onClick={() => this.props.exportPriceListAsXLSX(priceList, { exportTrees: category === 'Arbre', exportGreenSpaces: category === 'Espace vert', exportFurnitures: category === 'Mobilier' })}
                                >
                                    <FontAwesomeIcon icon={faDownload} />
                                </Button>}
                            <Button color='blue' style={{ padding: '8px' }} onClick={() => this.setState({ showSettings: true })}>
                                <FontAwesomeIcon icon={faGear} style={{ marginRight: '5px' }} />{i18n.t("Paramètres")}
                            </Button>
                        </div>
                        {displayType === 'list'
                            ? this.renderPriceList()
                            : <PriceListTable priceList={priceList} category={category} availableProperties={availableProperties} searchQuery={searchQuery} />}
                        <div style={{ paddingTop: '7px' }}>
                            <Button type='button' className='form-button' color='grey' onClick={this.props.cancel}>
                                <FontAwesomeIcon icon={faTimes} style={{ marginLeft: 0, marginRight: '10px' }} />{i18n.t("Annuler")}
                            </Button>
                            <Button type='button' className='form-button' color='green' disabled={!this.props.isOnline} onClick={() => this.handleSubmit(false)}>
                                <FontAwesomeIcon icon={faCheck} style={{ marginLeft: 0, marginRight: '10px' }} />{i18n.t("Valider")}
                            </Button>
                        </div>
                    </>}
            </>
        );
    }

    componentDidMount = () => {
        this.setState(prevState => ({
            priceList: { ...prevState.priceList, ...this.props.priceList, organizationId: this.props.activeOrganization.id },
            actions: [...this.props.actions].sort((a, b) => a.label.localeCompare(b.label))
        }));
    }

    renderSettings = () => {
        const { category, priceList } = this.state;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}>
                <Button color='grey' style={{ padding: '8px', width: 'fit-content', marginLeft: 'auto', height: '34px' }} onClick={() => this.setState({ showSettings: false })}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />{i18n.t("Retour")}
                </Button>
                <div style={{ flex: '1 1 auto', overflowY: 'auto', marginTop: '5px' }}>
                    {Object.keys(availableProperties).filter(property => availableProperties[property].category === category).map(property => {
                        const threshold = priceList.priceThresholds?.find(threshold => threshold.property === property) || { property, values: [] };

                        return (
                            <div>
                                <Header style={{ marginTop: '10px' }}>{availableProperties[property]?.label}</Header>
                                <div style={{ marginLeft: '5px' }}>
                                    {threshold.values.length ?
                                        threshold.values?.map((value, index) => (
                                            <>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                                                    <span>{i18n.t("De")}</span>
                                                    <div style={{ width: '90px' }}>
                                                        <Input type='number' fluid step='0.1' value={index ? threshold.values[index - 1] : 0} disabled />
                                                    </div>
                                                    {i18n.t("à")}
                                                    <div style={{ width: '135px' }}>
                                                        <Input
                                                            type='number' fluid step='0.1' label={availableProperties[property]?.unit} labelPosition='right'
                                                            value={value} onChange={(_, { value }) => this.handleThresholdChange(property, index, value)}
                                                        />
                                                    </div>
                                                    <Button color='red' size='tiny' style={{ padding: '10px 11px' }} onClick={(() => this.handleThresholdRemove(property, index))}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </Button>
                                                </div>
                                                {index === threshold.values.length - 1 &&
                                                    <div style={{ marginTop: '10px', width: 'fit-content' }}>
                                                        <Card
                                                            className='transparent' title={i18n.t('Ajouter un palier')}
                                                            style={{
                                                                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '30px', minHeight: '30px',
                                                                margin: '10px 0', marginLeft: '26px', boxShadow: 'none', fontSize: '17pt',
                                                                border: 'dashed 1px var(--grey-100)', backgroundColor: 'transparent', color: this.props.isDarkTheme ? 'white' : 'black'
                                                            }}
                                                            onClick={() => this.handleThresholdChange(property, index + 1, +threshold.values[index] + 1)}
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </Card>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {<span style={{ marginLeft: '9px' }}>{'>'}</span>}
                                                            <Input type='number' step='0.1' value={threshold.values[index]} label={availableProperties[property]?.unit} labelPosition='right' disabled style={{ margin: '0 0 0 8px', flex: '1 1 auto' }} />
                                                        </div>
                                                    </div>}
                                            </>
                                        ))
                                        :
                                        <Card
                                            className='transparent' title={i18n.t('Ajouter un palier')}
                                            style={{
                                                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '30px', minHeight: '30px', width: '183px',
                                                margin: '10px 0', marginLeft: '26px', boxShadow: 'none', fontSize: '17pt',
                                                border: 'dashed 1px var(--grey-100)', backgroundColor: 'transparent', color: this.props.isDarkTheme ? 'white' : 'black'
                                            }}
                                            onClick={() => this.handleThresholdChange(property, 0, 1)}
                                        >
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Card>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }

    renderPriceList = () => {
        const { category, actions, openedAccordions, priceList, searchQuery } = this.state;
        const currency = this.props.currencies.find(currency => currency.id === priceList.currencyId);
        const iconStyle = { marginLeft: '3px' };

        return (
            <Accordion style={{ flex: '1 1 auto', overflowY: 'auto', marginTop: '5px' }}>
                {actions
                    .filter(action => action.categories.includes(category) && (!searchQuery.trim() || FormattersUtil.getNormalizedString(action.label).includes(FormattersUtil.getNormalizedString(searchQuery))))
                    .map((action, index) => {
                        const price = priceList.prices?.find(price => price.actionId === action.id);
                        const property = price ? price.property : action.defaultProperty;
                        const threshold = priceList.priceThresholds?.find(pt => pt.property === property) || { values: [] };
                        const options = Object.keys(availableProperties)
                            .filter(property => !availableProperties[property].category || action.categories.includes(availableProperties[property].category))
                            .map(property => ({ text: availableProperties[property].label, value: property }));
                        const unit = availableProperties[property || 'default']?.unit;
                        const label = [undefined, null].includes(price?.label?.trim()) ? action.label : price.label;
                        const values = (price ? price.values || [] : new Array(category === 'Arbre' ? 6 : 1).fill().map((_, index) => action['price' + (index + 1)])).slice(0, threshold.values.length + 1);
                        let formattedCurrency = (currency?.symbol || currency?.code || '');
                        if (['surface', 'perimeter', 'length'].includes(property)) formattedCurrency += `/${availableProperties[property].unit}`;

                        return (
                            <>
                                <Accordion.Title active={openedAccordions.includes(index)} index={index} onClick={this.handleAccordionClick}>
                                    <Icon name='dropdown' />
                                    <span style={{ fontWeight: 'bold', fontSize: '12pt' }}>
                                        {label?.trim() || action.label}
                                        {action.definition && <InfoIcon content={action.definition} iconStyle={iconStyle} />}
                                        {values.length > 0 && (
                                            Math.min(...values) !== Math.max(...values)
                                                ? ` (${i18n.t("de")} ${Math.min(...values)} ${i18n.t("à")} ${Math.max(...values)}${formattedCurrency})`
                                                : (Math.min(...values) > 0 && ` (${Math.min(...values)}${formattedCurrency})`)
                                        )}
                                    </span>
                                </Accordion.Title>
                                <Accordion.Content active={openedAccordions.includes(index)} style={{ paddingLeft: '20px' }}>
                                    <Form>
                                        <Form.Field
                                            control={Input} label={i18n.t("Libellé de l'action") + ' :'} width={8}
                                            value={label} onChange={(_, { value }) => this.handlePriceChange(action.id, 'label', value)}
                                        />
                                        <CustomDropdown
                                            selectOnBlur={false} search={FormattersUtil.searchList} noResultsMessage={i18n.t("Aucun résultat trouvé")} width={8}
                                            label={i18n.t("Propriété de calcul") + ' :'} options={options} value={(price ? price.property : action.defaultProperty) || 'default'}
                                            onChange={(_, { value }) => this.handlePriceChange(action.id, 'property', value)}
                                        />
                                        <Segment style={{ marginTop: '10px', borderRadius: 'var(--radius-md)' }}>
                                            <Grid columns={2} style={{ padding: '10px' }}>
                                                {!property ?
                                                    <Grid.Column key={`${action.id}-0`} style={{ padding: '7px' }}>
                                                        <Form.Field>
                                                            <label>{`${i18n.t("Fixe")} :`}</label>
                                                            <Input
                                                                label={formattedCurrency} labelPosition='right' type='number' step='0.01' style={{ marginLeft: '7px' }}
                                                                value={values[0]} onChange={(_, { value }) => this.handlePriceChange(action.id, 'values', value, 0)}
                                                            />
                                                        </Form.Field>
                                                    </Grid.Column>
                                                    : (
                                                        threshold.values.length > 0 ?
                                                            threshold.values.map((value, index) => (
                                                                <>
                                                                    <Grid.Column key={`${action.id}-${threshold.property}-${index}`} style={{ padding: '7px' }}>
                                                                        <Form.Field>
                                                                            <label>{`${i18n.t("De")} ${index ? threshold.values[index - 1] : 0} ${i18n.t("à")} ${value}${unit} :`}</label>
                                                                            <Input
                                                                                label={formattedCurrency} labelPosition='right' type='number' step='0.01' style={{ marginLeft: '7px' }}
                                                                                value={values[index]} onChange={(_, { value }) => this.handlePriceChange(action.id, 'values', value, index)}
                                                                            />
                                                                        </Form.Field>
                                                                    </Grid.Column>
                                                                    {index === threshold.values.length - 1 &&
                                                                        <Grid.Column key={`${action.id}-${threshold.property}-${index + 1}`} style={{ padding: '7px' }}>
                                                                            <Form.Field>
                                                                                <label>{`> ${value}${unit} :`}</label>
                                                                                <Input
                                                                                    label={formattedCurrency} labelPosition='right' type='number' step='0.01' style={{ marginLeft: '7px' }}
                                                                                    value={values[index + 1]} onChange={(_, { value }) => this.handlePriceChange(action.id, 'values', value, index + 1)}
                                                                                />
                                                                            </Form.Field>
                                                                        </Grid.Column>}
                                                                </>
                                                            ))
                                                            :
                                                            <Grid.Column key={`${action.id}-${threshold.property}`} style={{ padding: '7px' }}>
                                                                <Form.Field style={{ marginBottom: '5px' }}>
                                                                    <label>{`${i18n.t("Toutes dimensions")} :`}</label>
                                                                    <Input
                                                                        label={formattedCurrency} labelPosition='right' type='number' step='0.01' style={{ marginLeft: '7px' }}
                                                                        value={values[0]} onChange={(_, { value }) => this.handlePriceChange(action.id, 'values', value, 0)}
                                                                    />
                                                                </Form.Field>
                                                                <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ showSettings: true })}>{i18n.t("Accéder aux paramètres pour configurer des prix par palier")}</a>
                                                            </Grid.Column>
                                                    )}
                                            </Grid>
                                        </Segment>
                                    </Form>
                                </Accordion.Content>
                            </>
                        );
                    })}
            </Accordion>
        );
    }

    handleAccordionClick = (_, { index }) => {
        this.setState(prevState => ({
            openedAccordions: prevState.openedAccordions.includes(index) ? prevState.openedAccordions.filter(i => i !== index) : [...prevState.openedAccordions, index]
        }));
    }

    handleChange = (_, { name, value }) => this.setState(prevState => ({ priceList: { ...prevState.priceList, [name]: value }, error: { ...prevState.error, [name]: false } }));

    handlePriceChange = (actionId, property, value, index = null) => {
        this.setState(prevState => {
            let prices = [...(prevState.priceList.prices || [])];

            let priceIndex = prices.findIndex(price => price.actionId === actionId);
            if (priceIndex === -1) {
                const action = this.props.actions.find(action => action.id === actionId);
                prices.push({
                    actionId: action.id,
                    property: action.defaultProperty,
                    values: new Array(this.state.category === 'Arbre' ? 6 : 1).fill().map((_, index) => action['price' + (index + 1)])
                });
                priceIndex = prices.length - 1;
            }

            if (property === 'values') {
                if (!prices[priceIndex].values[index] === undefined)
                    prices[priceIndex].values = [...(prices[priceIndex].values || []), ...new Array(index - (prices[priceIndex].values?.length || 0) + 1).fill().map(() => 0)];
                prices[priceIndex].values[index] = value;
            }
            else if (property === 'property') prices[priceIndex][property] = value === 'default' ? null : value;
            else prices[priceIndex][property] = value;

            return ({ priceList: { ...prevState.priceList, prices } });
        });
    }

    handleThresholdChange = (property, index, value) => {
        this.setState(prevState => {
            const priceThresholds = [...(prevState.priceList.priceThresholds || [])];

            let thresholdIndex = priceThresholds.findIndex(threshold => threshold.property === property);
            if (thresholdIndex === -1) {
                priceThresholds.push({ property, values: [] });
                thresholdIndex = priceThresholds.length - 1;
            }

            if (!priceThresholds[thresholdIndex].values[index] === undefined)
                priceThresholds[thresholdIndex].values = [...(priceThresholds[thresholdIndex].values || []), ...new Array(index - (priceThresholds[thresholdIndex].values?.length || 0) + 1).fill().map(() => 0)];
            priceThresholds[thresholdIndex].values[index] = value;

            return ({ priceList: { ...prevState.priceList, priceThresholds } });
        });
    }

    handleThresholdRemove = (property, index) => {
        this.setState(prevState => {
            const priceThresholds = [...(prevState.priceList.priceThresholds || [])];
            const threshold = priceThresholds.find(threshold => threshold.property === property);
            if (threshold) threshold.values.splice(index, 1);
            return ({ priceList: { ...prevState.priceList, priceThresholds } });
        });
    }

    handleSubmit = () => {
        const { isCreating } = this.props;
        const { priceList } = this.state;

        if (!priceList.label?.trim().length) {
            this.setState({ error: { label: true } });
            return;
        }

        for (let i = 0; i < priceList.prices.length; i++) {
            const price = priceList.prices[i];
            if (price.label === '') price.label = null;
            if (price.label) {
                price.label = price.label.trim();
                const action = this.props.actions.find(action => action.id === price.actionId);
                if (price.label === action?.label) price.label = null;
            }
        }

        //TODO Supprimer les prices qui correspondent au défaut ?

        this.setState({ isUpdating: true });
        if (isCreating)
            PriceListsService.addPriceList(priceList).then(response => {
                this.setState({ isUpdating: false }, () => {
                    if (response) {
                        this.props.updatePriceListList(response);
                        this.props.cancel();
                    }
                });
            })
        else PriceListsService.updatePriceList(priceList).then(response => {
            this.setState({ isUpdating: false }, () => {
                if (response) {
                    this.props.updatePriceListList(response);
                    this.props.cancel();
                }
            });
        });
    }
}



const mapStateToProps = (state) => {
    return {
        actions: state.actions,
        currencies: state.currencies,
        activeOrganization: state.activeOrganization,
        isDarkTheme: state.isDarkTheme,
        isOnline: state.isOnline
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceListForm);